import { render, staticRenderFns } from "./CustomerAddressModal.vue?vue&type=template&id=6c4788ba&"
import script from "./CustomerAddressModal.vue?vue&type=script&lang=ts&"
export * from "./CustomerAddressModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports